import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import {_} from 'utils/i18n';

import Portal from 'scripts/components/Portal';
import MaterialIcon from 'scripts/components/MaterialIcon';

import LessonAbortModal from './LessonAbortModal';

const Title = _('Abort this Lesson');
const Label = _('Abort lesson');

const AbortModal = ({show, url, onClick, ...props}) => (
    <Fragment>
        <Portal container="header-top-nav-container">
            {url && <li>
                <a className="lesson-abort-button" href={url} onClick={onClick}>
                    <MaterialIcon className="flex space-x-2 items-center" type="close" />
                    <span className="hide-on-small-and-down">{Label}</span>
                </a>
            </li>}
        </Portal>
        {show && <LessonAbortModal {...props} title={Title} />}
    </Fragment>
);

AbortModal.propTypes = {
    show: PropTypes.bool.isRequired,
    url: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};

AbortModal.defaultProps = {
    url: null,
};

export default AbortModal;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonAbortModal/Wrapper.js